<template>
  <div class="h-full flex flex-col">
    <!-- Select des ressources -->
    <div class="flex w-fit mb-4">
      <div class="relative w-fit">
        <select class="w-fit basicInput" v-model="selectedRessource">
          <option class="text-center" value="">Sélectionner une ressource</option>
          <option value="all">Toutes les ressources</option>
          <option v-for="team in teams" :key="team" :value="team">
            Équipe {{ team }}
          </option>
          <option v-for="ressource in filteredResources" :key="ressource.id" :value="ressource.id">
            {{ ressource.lastName }} {{ ressource.firstName }}
          </option>
        </select>
        <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">
          Ressources
        </span>
      </div>
      <!-- Bouton ajout -->
      <button
        type="button"
        class="callToAction h-9 !px-4 text-sm flex items-center !mx-0 !ml-2 cursor-pointer"
        :disabled="!selectedRessource"
        @click="addRessourceToobject"
      >
        Ajouter
      </button>
      <!-- Bouton suppression -->
      <button
        type="button"
        class="!h-9 !px-4 py-2 !rounded-xl text-sm flex items-center !mx-0 !ml-1 cursor-pointer"
        :disabled="!clickedRessource"
        @click="object.ressources = object.ressources.filter(r => r.ressourceId !== clickedRessource); clickedRessource = null"
      >
        Supprimer
      </button>
    </div>
    <!-- Tableau des ressources -->
    <div class="overflow-y-auto bg-white flex-1">
      <table class="min-w-full border border-gray-200 shadow-md rounded-lg bg-white">
        <thead class="bg-[#1E1017] text-white font-bold text-left sticky top-0">
          <tr>
            <th class="px-4 py-2 border-b">Nom</th>
            <th class="px-4 py-2 border-b">Prénom</th>
            <th class="px-4 py-2 border-b">Équipe</th>
            <th class="px-4 py-2 border-b">Poste</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ressource in objectRessources" :key="ressource.id"
            :class="['hover:bg-red-100 text-left even:bg-red-50 odd:bg-white', { '!bg-red-200': clickedRessource === ressource.ressourceId }]"
            @click="clickedRessource = ressource.ressourceId"
          >
            <td class="px-4 py-2 border-b border-gray-300 text-gray-700">{{ ressource.lastName }}</td>
            <td class="px-4 py-2 border-b border-gray-300 text-gray-700">{{ ressource.firstName }}</td>
            <td class="px-4 py-2 border-b border-gray-300 text-gray-700">{{ ressource.team }}</td>
            <td class="px-4 py-2 border-b border-gray-300 text-gray-700">{{ ressource.position }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { fetchRessources } from '@/services/ressourceService';

export default{
  props: {
    object: Object,
  },
  data(){
    return{
      selectedRessource: '',
      clickedRessource: null,
      ressources: [],
      teams: []
    }
  },
  computed: {
    filteredResources() {
      if (this.object && this.object.ressources) {
        return this.ressources.filter(ressource => 
          !this.object.ressources.some(r => r.ressourceId === ressource.id)
        );
      }
      
      return this.ressources;
    },
    objectRessources(){
      if(this.object && this.object.ressources) {
        const eventR = this.object.ressources.map(ressource => {
          const foundRessource = this.ressources.find(r => r.id === ressource.ressourceId);
          return foundRessource ? { ...foundRessource, ...ressource} : null;
        }).filter(ressource => ressource !== null);

        return eventR;
      }
      return [];
    },
    addRessourceToobject(){
      if(this.selectedRessource == 'all'){
        this.object.ressources = this.ressources.map(ressource => ({ ressourceId: ressource.id }));
      } 
      else if(this.teams.includes(this.selectedRessource)){
        const ressourceInTeam = this.ressources.filter(ressource => ressource.team === this.selectedRessource);
        for(const ressource of ressourceInTeam){
          if(!this.object.ressources.some(r => r.ressourceId === ressource.id)){
            // Si la ressource n'est pas déjà présente, on l'ajoute
            this.object.ressources.push({ ressourceId: ressource.id });
          }
        }
      }
      else{
        this.object.ressources.push({ ressourceId: this.selectedRessource }); 
      }

      this.selectedRessource = ''
    }
  },
  async mounted(){
    this.ressources = await fetchRessources();

    this.teams = this.ressources
    .map(ressource => ressource.team)
    .filter((value, index, self) => value !== "" && self.indexOf(value) === index);
  }
}

</script>

<style scoped>
.bg-red-200 {
  background-color: #fecaca !important;
}
table {
  border-collapse: separate; /* Nécessaire pour utiliser border-radius */
  border-spacing: 0;
}

/* Arrondir le coin supérieur gauche et supérieur droit du header */
thead tr th:first-child {
  border-top-left-radius: 8px;
}
thead tr th:last-child {
  border-top-right-radius: 8px;
}

/* Coins inférieurs de la dernière ligne */
tbody tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
tbody tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}
</style>